import { createSlice } from "@reduxjs/toolkit";

export const invalidDialogSlice = createSlice({
  name: "invalidDialog",
  initialState: {
    open: false,
  },
  reducers: {
    setInvalidDialog: (state, action) => {
      state.open = action.payload;
    },
    resetDialog: (state) => {
      state.links = false;
    },
  },
});

// this is for dispatch
export const { setInvalidDialog, resetDialog } = invalidDialogSlice.actions;

export const getInvalidDialogProp = (state) => state?.invalidDialog?.open;

// this is for configureStore
export default invalidDialogSlice.reducer;
